export enum AuthGuardAccess {
  PUBLIC,
  PUBLIC_AND_AUTHORIZED,
  REGISTER_COMPANY,
  REGISTER_DOCUMENTS,
  DASHBOARD,
}
